import { render, staticRenderFns } from "./Opening.vue?vue&type=template&id=a2ae6a06&scoped=true&"
import script from "./Opening.vue?vue&type=script&lang=js&"
export * from "./Opening.vue?vue&type=script&lang=js&"
import style0 from "./Opening.vue?vue&type=style&index=0&id=a2ae6a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ae6a06",
  null
  
)

export default component.exports